import { createGlobalStyle } from 'styled-components';
import { createCssVariables } from '../../shared/cjs/createCssVariables';
export const CssVariables = createGlobalStyle([":root{", "}"], _ref => {
  let {
    theme
  } = _ref;
  return createCssVariables(theme);
});
//# sourceMappingURL=CssVariables.js.map